<template>
	<div class="inner-page cases">
    
		<AppHead :title="`${team.name} Cases`" />

		<PageHeader 
			:title="`${team.name} Cases`"
			:desc="`Cases belonging to the distributor ${team.name}`"
			:hasButton="permissions.canCreateProject"
			buttonLabel="Create new case"
			buttonRoute="/cases/new-case"
			:showHelper="false"
			/>


		<div class="cases-list" v-if="cases && cases.length > 0">
			<CaseOverviewRow 
				v-for="(theCase, index) in cases"
				:key="index"
				:thisCase="theCase"
				:caseID="theCase.hashid"
				:visibleCaseID="theCase.enquiry_number ? theCase.enquiry_number : theCase.hashid"
				:description="theCase.description"
				:steps="theCase.progress_stage"
				:commentCount="theCase.chat_count"
				:assignTeam="permissions.canAssignProjectToTeam"
				:assignManager="permissions.canAssignProjectManager"
				:allPotentialManagers="allPotentialManagers"
				:team="theCase.teams"
				:teams="allTeams"
				:permissions="permissions"
				/>

		</div>
		<Placeholder v-else message="This distributor does not currently have any active Cases" />

	</div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"
import CaseOverviewRow from "@/Components/Cases/CaseOverviewRow"

export default {
	components: {
		AppLayout,
    AppHead,
    PageHeader,
    Subtitle,
    Placeholder,
    CaseOverviewRow
	},
	layout: AppLayout,
  props: [
		'team',
    'cases',
    'permissions',
    'allPotentialManagers',
		'allTeams'
  ],
  methods: {
    
  },
  mounted(){
    // console.log(this.cases)
  }
};
</script>